import {Component} from '@angular/core'

@Component({
  selector: 'app-user-icon',
  templateUrl: './user-icon.svg',
})
export class UserIconComponent {
  constructor() {}
}
